import React from 'react'
import { Card } from '../card/Card'
import { PhoneHeader } from './PhoneHeader'

type CardHeaderProps = {
   title: string
   action?: JSX.Element
   secondaryAction?: boolean
   children?: JSX.Element
   hideInPhone?: boolean
   noMaxHeight?: boolean
}

export const CardHeader = ({ title, action, secondaryAction, children, hideInPhone, noMaxHeight }: CardHeaderProps) => {
   return (
      <>
         {!hideInPhone && <PhoneHeader title={title} action={action} secondaryAction={secondaryAction} />}
         <Card noMaxHeight title={title} action={action} transparentInPhone>
            <>{children}</>
         </Card>
      </>
   )
}
